var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 286,
    viewBox: "0 0 427 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.936 0C298.302 70.5611 356.439 128.698 427 125.064C374.607 172.418 374.607 254.582 427 301.936C356.439 298.302 298.302 356.439 301.936 427C254.582 374.607 172.418 374.607 125.064 427C128.698 356.439 70.5611 298.302 0 301.936C52.3934 254.582 52.3934 172.418 0 125.064C70.5611 128.698 128.698 70.5611 125.064 0C172.3 52.3934 254.582 52.3934 301.936 0Z",
    fill: "#D8FF3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon1);
export default __webpack_public_path__ + "static/media/statisticsIcon1.2ad3d845427a71feb2eb5ac45c475007.svg";
export { ForwardRef as ReactComponent };